import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { BOOKMARK_BUTTON_TRANSLATION_KEY } from "../constants";
export default /*#__PURE__*/_defineProperty({}, BOOKMARK_BUTTON_TRANSLATION_KEY, {
  BMK_BOOKMARK_SAVE_COURSE_TITLE: 'Guardar curso',
  BMK_BOOKMARK_SAVED_COURSE_TITLE: 'Curso guardado'
});